﻿// About Us — Elements PDP CRO injector (Sprint 27efe953, updated 2026-06-21)
// Adds: BOGO offer line, 460gsm trust bullet, size guide link, 460gsm spec block.
// Targets: /products/elements-hoodie-* only.
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (!location.pathname.match(/\/products\/elements-hoodie/i)) return;
  if (window.__auElementsCroLoaded) return;
  window.__auElementsCroLoaded = true;

  var BRAND_NAVY = '#131936';
  var BRAND_MILK = '#F4F1EA';
  var FONT_BODY = "'Raleway', 'Helvetica Neue', sans-serif";
  var FONT_DISPLAY = "'Unbounded', 'Helvetica Neue', sans-serif";

  // â”€â”€ Shared style injection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  var style = document.createElement('style');
  style.textContent = [
    '.au-bogo-line{',
      'font-family:' + FONT_BODY + ';',
      'font-size:14px;color:' + BRAND_NAVY + ';',
      'margin:10px 0 14px;line-height:1.5;',
    '}',
    '.au-trust-list{',
      'list-style:none;padding:0;margin:0 0 18px;',
    '}',
    '.au-trust-list li{',
      'font-family:' + FONT_BODY + ';',
      'font-size:13px;color:rgba(19,25,54,0.72);',
      'padding:3px 0;line-height:1.5;',
    '}',
    '.au-trust-list a{color:inherit;text-decoration:underline;text-underline-offset:2px;}',
    '.au-elements-spec{',
      'padding:28px 0 8px;border-top:1px solid rgba(19,25,54,0.1);margin-top:28px;',
    '}',
    '.au-elements-spec__heading{',
      'font-family:' + FONT_DISPLAY + ';',
      'font-size:12px;font-weight:700;',
      'color:' + BRAND_NAVY + ';letter-spacing:0.06em;',
      'text-transform:uppercase;margin:0 0 18px;line-height:1.4;',
    '}',
    '.au-elements-spec__table{width:100%;border-collapse:collapse;}',
    '.au-elements-spec__table td{',
      'font-family:' + FONT_BODY + ';',
      'font-size:13px;color:' + BRAND_NAVY + ';',
      'padding:9px 0;border-bottom:1px solid rgba(19,25,54,0.08);',
      'line-height:1.5;vertical-align:top;',
    '}',
    '.au-elements-spec__table td:first-child{',
      'color:rgba(19,25,54,0.52);width:48%;padding-right:12px;',
    '}',
    '.au-bloom-pdp-removed{display:none !important;}',
  ].join('');
  document.head.appendChild(style);

  // â”€â”€ Selectors with fallbacks â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function qs(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function insertAfter(newNode, refNode) {
    if (refNode && refNode.parentNode) {
      refNode.parentNode.insertBefore(newNode, refNode.nextSibling);
      return true;
    }
    return false;
  }

  function insertBefore(newNode, refNode) {
    if (refNode && refNode.parentNode) {
      refNode.parentNode.insertBefore(newNode, refNode);
      return true;
    }
    return false;
  }

  // â”€â”€ Wait for DOM to have product info â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  function init() {
    // 1. BOGO offer line â€” inject directly after the price element
    // Horizon theme uses <product-price> custom element -- list it first
    var priceEl = qs([
      'product-price',
      'span.regular-price',
      '.product__price',
      '.price__regular',
      '.price-item--regular',
      '[class*="product-price"]',
      '.product-single__price',
      'price-money',
      '.price',
    ]);
    if (priceEl) {
      // product-price is block-level; only walk up from inline elements
      var priceContainer = priceEl;
      var tag0 = priceContainer.tagName.toLowerCase();
      if (tag0 !== 'product-price' && tag0 !== 'div' && tag0 !== 'p' && tag0 !== 'section') {
        for (var depth = 0; depth < 4; depth++) {
          var parent = priceContainer.parentElement;
          if (!parent) break;
          var tag = parent.tagName.toLowerCase();
          if (tag === 'div' || tag === 'p' || tag === 'section' || tag === 'form' || tag === 'product-price') break;
          priceContainer = parent;
        }
      }
      var bogoEl = document.createElement('p');
      bogoEl.className = 'au-bogo-line';
      bogoEl.textContent = 'Every hoodie comes with your choice of tee. Worn together, checked out once.';
      insertAfter(bogoEl, priceContainer);
    }

    // 2. Trust/risk-reversal block â€” inject just above the ATC button
    var atcBtn = qs([
      'button[name="add"]',
      '.product-form__submit',
      '[data-testid="Checkout-button"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.btn--add-to-cart',
    ]);
    if (atcBtn) {
      var trustEl = document.createElement('ul');
      trustEl.className = 'au-trust-list';
      trustEl.innerHTML = [
        '<li>&#x2713; 460gsm premium heavyweight fleece</li>',
        '<li>&#x2713; Complimentary shipping Australia-wide</li>',
        '<li>&#x2713; 30-day returns, no questions</li>',
        '<li>&#x2713; Premium tee included</li>',
        '<li><a href="/pages/size-guide-hoodie">Find your size &rarr;</a></li>',
      ].join('');
      // Insert before the button's wrapper if there is one, else before the button
      var atcWrap = atcBtn.closest('.product-form__buttons, .product-form__cart, [class*="buy-buttons"]') || atcBtn;
      insertBefore(trustEl, atcWrap);
    }

    // 3. 460gsm spec block â€” inject at end of product description or before feature images
    var specTarget = qs([
      '.product__description',
      '.product-single__description',
      '[class*="product-description"]',
      '.rte',
    ]);
    if (specTarget) {
      var specEl = document.createElement('div');
      specEl.className = 'au-elements-spec';
      specEl.innerHTML = [
        '<h3 class="au-elements-spec__heading">Built heavier than the average hoodie. Hereâ€™s the spec.</h3>',
        '<table class="au-elements-spec__table"><tbody>',
          '<tr><td>Fabric weight</td><td>460gsm</td></tr>',
          '<tr><td>Material</td><td>Premium heavyweight fleece</td></tr>',
          '<tr><td>Interior</td><td>Double-brushed</td></tr>',
          '<tr><td>Construction</td><td>Anti-pilling, structured drape</td></tr>',
          '<tr><td>Designed</td><td>Melbourne</td></tr>',
          '<tr><td>Set</td><td>Your choice of tee, checked out once</td></tr>',
        '</tbody></table>',
      ].join('');
      // Append to end of description so it sits just below the description text
      specTarget.appendChild(specEl);
    }

    // 4. Remove inline Bloom coming-soon banner if it exists on Elements PDP
    //    (it will render globally from the au-bloom-coming-soon section instead)
    var bloomSelectors = [
      '[class*="bloom"]',
      '[id*="bloom"]',
      '[data-section-type*="bloom"]',
    ];
    bloomSelectors.forEach(function(sel) {
      var existing = document.querySelectorAll(sel);
      existing.forEach(function(el) {
        // Only hide if it looks like the coming-soon banner (not other Bloom references)
        var text = (el.textContent || '').toLowerCase();
        if (text.includes('coming soon') || text.includes('bloom range') || text.includes('bloom â€”') || text.includes('arriving')) {
          el.classList.add('au-bloom-pdp-removed');
        }
      });
    });
  }

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
